import { SearchTextbox } from "front-end/components/search-textbox.component";

export class QuickSearchService {
    private _currentContext: JQuery = $();

    private _searchTextBox: SearchTextbox = null;

    private _classMap = {
        js: {
            toggle: ".js-ina-quick-search__btn"
        }
    };

    private _toggle: JQuery = null;

    private handleSubmit(): void {
        if(!this._searchTextBox.isOpened) {
            this._searchTextBox.open();
        } else {
            const searchForm = this._currentContext.get(0) as HTMLFormElement;
            searchForm.submit();
        }
    }

    private handleToggle(): void {
        if (!this._searchTextBox.isOpened) {
            this._toggle.addClass("hidden");
            this._searchTextBox.open();
        }
    }

    private bindEvents(): void {
        this._toggle.on("click", (e) =>
        {
            e.preventDefault();
            this.handleToggle();
        });
        this._searchTextBox.on("submit")
            .subscribe(() => this.handleSubmit());
    }

    private parseContext(): void {
        this._toggle = $(this._classMap.js.toggle, this._currentContext);
        const searchTextBoxContext = $(SearchTextbox.SELECTOR, this._currentContext);
        const searchTextBox = new SearchTextbox();
        searchTextBox.init(searchTextBoxContext);
        this._searchTextBox = searchTextBox;
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
